import { MbscModule } from '@mobiscroll/angular';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { CurrencyPipe, registerLocaleData } from '@angular/common';
import localeEs from '@angular/common/locales/es';
import { QuillModule } from 'ngx-quill';

registerLocaleData(localeEs);


import { AppRoutingModule } from './app-routing.module';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';
import { SocketioService } from './services/socket/socketio.service';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';

import { AppComponent } from './app.component';
import { DescargasEnCursoComponent } from './components/descargas-en-curso/descargas-en-curso.component';
import { NavbarauthComponent } from './components/navbarauth/navbarauth.component';
import { AppsLauncherComponent } from './components/apps-launcher/apps-launcher.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LoginComponent } from './components/auth/login-form/login.component';
import { AuthService } from './services/auth/auth.service';
import { ComercioInterceptorService } from './interceptor/comercio-interceptor.service';
import { AuthInterceptorService } from './interceptor/auth-interceptor.service';
import { RbacMarcadorInterceptor } from './services/rbac/rbac-marcador.interceptor';
import { LogoutComponent } from './components/auth/logout/logout.component';
import { NoAuthGuard } from './guards/NoAuth.guard';
import { JwtModule } from "@auth0/angular-jwt";
import { RegistroComponent } from './components/auth/registro/registro.component';
import { UserService } from './services/user/user.service';
import { PaymentOptionsService } from './services/payment-options/payment-options.service';
import { BdvAsyncManagementService } from './services/bdv-async-management.service';
import { LaService } from './modules/la/servises/la.service';
import { ApprovalPoliciesService } from './services/approval-policies.service';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { IdentGuard } from './guards/ident.guard';
import { IsAuthGuard } from './guards/isAuth.guard';
import { ChatComponent } from './components/chat/chat.component';
import { SearchClientComponent } from './components/search-client/search-client.component';
import { ConsultaPsicometricoComponent } from './components/consulta-psicometrico/consulta-psicometrico.component';
import { ListOnlineComponent } from './components/list-online/list-online.component';
import { ProfilesComponent } from './components/profiles/profiles.component';
import { ContactsComponent } from './components/contacts/contacts.component';
import { ContactProfileComponent } from './components/contact-profile/contact-profile.component';
import { RewardsCardComponent } from './components/contact-profile/rewards-card/rewards-card.component';
import { CommonModule } from '@angular/common';
import { ConsultQuoteComponent } from './components/consult-quote/consult-quote.component';
import { CreditOptionComponent } from './components/credit-option/credit-option.component';
import { ConsultQuotaComponent } from './components/consult-quota/consult-quota.component';
import { CreditCalculatorComponent } from './components/credit-calculator/credit-calculator.component';
import { CreditSaveComponent } from './components/credit-save/credit-save.component';
import { CreditSaveV2Component } from './components/credit-save-v2/credit-save-v2.component';
import { InvoiceComponent } from './components/invoice/invoice.component';
import { ValidatePhoneComponent } from './components/validate-phone/validate-phone.component';
import { ApproveConditionsComponent } from './components/approve-conditions/approve-conditions.component';
import { ApprovalPoliciesComponent } from './components/approval-policies/approval-policies.component';
import { AgeLimitsComponent } from './components/age-limits/age-limits.component';
import { GroupListComponent } from './components/group-list/group-list.component';
import { WorkConditionMasterComponent } from './components/work-condition-master/work-condition-master.component';
import { ContactOnboardingComponent } from './components/contact-onboarding/contact-onboarding.component';
import { ContactSapComponent } from './components/contact-sap/contact-sap.component';
import { SapHubComponent } from './components/sap-hub/sap-hub.component';
import { ContactOdooComponent } from './components/contact-odoo/contact-odoo.component';
import { OdooPanelComponent } from './components/odoo/odoo-panel/odoo-panel.component';
import { OdooResumenComponent } from './components/odoo/odoo-resumen/odoo-resumen.component';
import { OdooClientesComponent } from './components/odoo/odoo-clientes/odoo-clientes.component';
import { OdooComerciosComponent } from './components/odoo/odoo-comercios/odoo-comercios.component';
import {
  OdooFechaCortaPipe, OdooDiaLargoPipe, OdooHoraSolaPipe, OdooRifPipe, OdooFrasePipe,
} from './services/odoo/odoo-maestros-formato';
import { OdooArchivosComponent } from './components/odoo/odoo-archivos/odoo-archivos.component';
import { OdooGeneracionComponent } from './components/odoo/odoo-archivos/odoo-generacion.component';
import { OdooBitacoraComponent } from './components/odoo/odoo-bitacora/odoo-bitacora.component';
import { OdooConfigComponent } from './components/odoo/odoo-config/odoo-config.component';
import { OdIconComponent } from './components/odoo/od-icon/od-icon.component';
import { OdooToastComponent } from './components/odoo/odoo-toast/odoo-toast.component';
import { OdPaginadorComponent } from './components/odoo/od-paginador/od-paginador.component';
import { OdSheetComponent } from './components/odoo/od-sheet/od-sheet.component';
import { OdEventoDetalleComponent } from './components/odoo/od-evento-detalle/od-evento-detalle.component';
import { OdKvComponent } from './components/odoo/od-kv/od-kv.component';
import {
  OdooEstadoPipe, OdooFechaPipe, OdooDiaPipe, OdooUsdPipe, OdooTipoPipe, OdooAccionPipe, OdooHoraPipe,
} from './services/odoo/odoo-formato';
import { ContactFinancialPaymentsComponent } from './components/contact-financial-payments/contact-financial-payments.component';
import { PostComponent } from './components/post/post.component';
import { OtrosFlujosPagoComponent } from './components/otros-flujos-pago/otros-flujos-pago.component';
import { NotaCreditoComponent } from './components/nota-credito/nota-credito.component';
import { PersonPaymentsComponent } from './components/person-payments/person-payments.component';
import { EmpresaCuentaPipe, EmpresaCuentaClasePipe } from './pipes/empresa-cuenta.pipe';
import { PersonPaymentsTableComponent } from './components/person-payments-table/person-payments-table.component';
import { PersonPaymentsSwitcherComponent } from './components/person-payments-switcher/person-payments-switcher.component';
import { PreferenciasComponent } from './components/preferencias/preferencias.component';
import { TarifarioComponent } from './components/comercios/tarifario/tarifario.component';
import { FeriadosComponent } from './components/comercios/feriados/feriados.component';
import { LiquidacionDiaComponent } from './components/liquidacion/liquidacion-dia/liquidacion-dia.component';
import { LiquidacionLotesComponent } from './components/liquidacion/liquidacion-lotes/liquidacion-lotes.component';
import { EstampaComercioComponent } from './components/estampa-comercio/estampa-comercio.component';
import { CopiarComponent } from './components/copiar/copiar.component';
import { FichaLiquidacionComponent } from './components/liquidacion/ficha-liquidacion/ficha-liquidacion.component';
import { AtencionComerciosComponent } from './components/liquidacion/atencion-comercios/atencion-comercios.component';
import { FichaTandaComponent } from './components/liquidacion/ficha-tanda/ficha-tanda.component';
import { LiquidacionPorResolverComponent } from './components/liquidacion/liquidacion-por-resolver/liquidacion-por-resolver.component';
import { LiquidacionConsultasComponent } from './components/liquidacion/liquidacion-consultas/liquidacion-consultas.component';
import { LiquidacionMarcaVentaComponent } from './components/liquidacion/liquidacion-marca-venta/liquidacion-marca-venta.component';
import { LiquidacionCuentasComponent } from './components/liquidacion/liquidacion-cuentas/liquidacion-cuentas.component';
import { LiquidacionCuentasCtComponent } from './components/liquidacion/liquidacion-cuentas-ct/liquidacion-cuentas-ct.component';
import { LiquidacionCuadreDiaComponent } from './components/liquidacion/liquidacion-cuadre-dia/liquidacion-cuadre-dia.component';
import { CargandoCuadrosComponent } from './components/liquidacion/cargando-cuadros/cargando-cuadros.component';
import { LiquidacionUtilidadComponent } from './components/liquidacion/liquidacion-utilidad/liquidacion-utilidad.component';
import { LiquidacionCuotasMediasComponent } from './components/liquidacion/liquidacion-cuotas-medias/liquidacion-cuotas-medias.component';
import { LiquidacionAvisoComponent } from './components/liquidacion/liquidacion-aviso/liquidacion-aviso.component';
import { LiquidacionCobranzaComponent } from './components/liquidacion/liquidacion-cobranza/liquidacion-cobranza.component';
import { LiquidacionReversosComponent } from './components/liquidacion/liquidacion-reversos/liquidacion-reversos.component';
import { LiquidacionSaludCobrosComponent } from './components/liquidacion/liquidacion-salud-cobros/liquidacion-salud-cobros.component';
import { LiquidacionCalendarioComponent } from './components/liquidacion/liquidacion-calendario/liquidacion-calendario.component';
import { LiquidacionCalendarioMesComponent } from './components/liquidacion/liquidacion-calendario-mes/liquidacion-calendario-mes.component';
import { CuentasOrigenComponent } from './components/liquidacion/cuentas-origen/cuentas-origen.component';
import { ParametrosLiquidacionComponent } from './components/liquidacion/parametros-liquidacion/parametros-liquidacion.component';
import { MontoBsComponent } from './components/liquidacion/monto-bs/monto-bs.component';
import { LiquidacionFirmaComponent } from './components/liquidacion/liquidacion-firma/liquidacion-firma.component';
import { LiquidacionGuiaDiagramasComponent } from './components/liquidacion/liquidacion-guia-diagramas/liquidacion-guia-diagramas.component';
import { LiquidacionGuiaComponent } from './components/liquidacion/liquidacion-guia/liquidacion-guia.component';
import { LiquidacionResumenComponent } from './components/liquidacion/liquidacion-resumen/liquidacion-resumen.component';
import { BandasComponent } from './components/liquidacion/bandas/bandas.component';
import { IntegracionesComponent } from './components/liquidacion/integraciones/integraciones.component';
import { WebcamComponent } from './components/webcam/webcam.component';
import { WebcamModule } from 'ngx-webcam';
import { NgToggleModule } from 'ng-toggle-button';

import { BiometriaComponent } from './components/biometria/biometria.component';
import { FinancialPaymentsComponent } from './components/financial-payments/financial-payments.component';
import { PaymentsComponent } from './components/payments/payments.component';
import { FinancePaymentsTableComponent } from './components/finance-payments-table/finance-payments-table.component';
import { FinancePaymentsSwitcherComponent } from './components/finance-payments-switcher/finance-payments-switcher.component';
import { StadisticComponent } from './components/stadistic/stadistic.component';
import { InstallmentsConsoleComponent } from './components/installments-console/installments-console.component';
import { DataProfileComponent } from './components/data-profile/data-profile.component';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { AddressComponent } from './components/address/address.component';
import { WorkingConditionComponent } from './components/working-condition/working-condition.component';
import { IncomeComponent } from './components/income/income.component';
import { ReportComponent } from './components/report/report.component';
import { ContactsApprovatedComponent } from './components/contacts-approvated/contacts-approvated.component';
import { ExportComponent } from './components/export/export.component';
import { CreateContactComponent } from './components/create-contact/create-contact.component';
import { DashboardInviceComponent } from './components/dashboard-invice/dashboard-invice.component';
import { UsersComponent } from './components/users/users.component';
import { LineChartComponent } from './components/line-chart/line-chart.component';
import { BarChartComponent } from './components/bar-chart/bar-chart.component';
import { DemographicBarChartComponent } from './components/insurance-console/components/demographic-bar-chart/demographic-bar-chart.component';
import { FinancalDashboardComponent } from './components/financal-dashboard/financal-dashboard.component';
import { StadisticDashboardComponent } from './components/stadistic-dashboard/stadistic-dashboard.component';
import { StadisticEjecutivesComponent } from './components/stadistic-ejecutives/stadistic-ejecutives.component';
import { IsProfileGuard } from './guards/isProfile.guard';
import { IsPermissionGuard } from './guards/isPermission.guard';
import { DashboardDirecDebitComponent } from './components/dashboard-direc-debit/dashboard-direc-debit.component';
import { DomiciliacionCtCardComponent } from './components/domiciliacion-ct-card/domiciliacion-ct-card.component';
import { DomiciliacionCtAvanceComponent } from './components/domiciliacion-ct-avance/domiciliacion-ct-avance.component';
import { EstadoCtBadgeComponent } from './components/estado-ct-badge/estado-ct-badge.component';
import { DomiciliationConfigDashboardComponent } from './components/domiciliation-config-dashboard/domiciliation-config-dashboard.component';
import { CobrosReaderComponent } from './components/cobros-reader/cobros-reader.component';
import { RegistroCobrosArchivoComponent } from './components/registro-cobros-archivo/registro-cobros-archivo.component';
import { DirectDebitService } from './services/direct-debit/direct-debit.service';
import { PaymentMethodComponent } from './components/payment-method/payment-method.component';
import { InsuranceDomiciliationSimulatorComponent } from './components/insurance-domiciliation-simulator/insurance-domiciliation-simulator.component';
import { DndComponent } from './components/dashboard-direc-debit/dnd/dnd.component';
import { DndAlliancesComponent } from './components/dashboard-direc-debit-alliances/dnd/dnd.component';
import { DndComponent as DndAfiliationComponent } from './components/dashboard-direct-debit-affiliation/dnd/dnd.component';

import { ProgressDndComponent } from './components/dashboard-direc-debit/progress-dnd/progress-dnd.component';
import { DndDirective } from './directives/dnd.directive';
import { DirecDebitHistoryComponent } from './components/direc-debit-history/direc-debit-history.component';

import { CurrencyMaskModule } from "ng2-currency-mask";
import { EditComponent } from './components/payment-method/edit/edit.component';
import { NotificationXlsxComponent } from './components/notification-xlsx/notification-xlsx.component';
import { NumbersOnlyDirective } from './directives/numbers-only.directive';
import { DashboardDirecDebitAlliancesComponent } from './components/dashboard-direc-debit-alliances/dashboard-direc-debit-alliances.component';

import { RatesComponent } from './components/rates/rates.component';
import { PlansComponent } from './components/plans/plans.component';
import { PlanDetailComponent } from './components/plans/plan-detail/plan-detail.component';
import { NewPlanComponent } from './components/new-plan/new-plan.component';
import { CargaMasivaClientComponent } from './components/carga-masiva-client/carga-masiva-client.component';
import { DirecDebitAlliancesHistoryComponent } from './components/direc-debit-alliances-history/direc-debit-alliances-history.component';

import { TraceDocumentComponent } from './components/dashboard-direc-debit/trace-document/trace-document.component';
import { EditDataBaseComponent } from './components/edit-data-base/edit-data-base.component';
import { DashboardDirectDebitAffiliationComponent } from './components/dashboard-direct-debit-affiliation/dashboard-direct-debit-affiliation.component';
import { DirecDebitAfiliationsHistoryComponent } from './components/direc-debit-afiliations-history/direc-debit-afiliations-history.component';
import { ConciliationProgressMonitorComponent } from './components/conciliation-progress-monitor/conciliation-progress-monitor.component';
import { ClientPlansComponent } from './components/person-plans/person-plans.component';
import { AccountsAdminComponent } from './components/accounts-admin/accounts-admin.component';
import { PaymentOptionsComponent } from './components/payment-options/payment-options.component';
import { DeactivationCategoriesComponent } from './components/deactivation-categories/deactivation-categories.component';
import { CarteraCastigadaComponent } from './components/cartera-castigada/cartera-castigada.component';
import { BdvAsyncManagementComponent } from './components/bdv-async-management/bdv-async-management.component';
import { BdvConsultasComponent } from './components/bdv-consultas/bdv-consultas.component';
import { CargaMasivaAprobacionesComponent } from './components/carga-masiva-aprobaciones/carga-masiva-aprobaciones.component';
import { CargaMasivaCuposComponent } from './components/carga-masiva-cupos/carga-masiva-cupos.component';
import { CargaMasivaCuposRewardsComponent } from './components/carga-masiva-cupos-rewards/carga-masiva-cupos-rewards.component';
import { CargaMasivaC004Component } from './components/carga-masiva-c004/carga-masiva-c004.component';
// import { ClientsStadisticAuthComponent } from './components/clients-stadistic-auth/clients-stadistic-auth.component';
import { ClientsStadisticAuthComponent } from './components/clients-stadistic-auth/clients-stadistic-auth.component';
import { OrdersExportsComponent } from './components/orders-exports/orders-exports.component';
import { DashboardFeesComponent } from './components/dashboard-fees/dashboard-fees.component';
import { ProcesosMasivosComponent } from './components/procesos-masivos/procesos-masivos.component';
import { ProcesoDetalleComponent } from './components/procesos-masivos/proceso-detalle/proceso-detalle.component';
import { CarteraComponent } from './components/cartera/cartera.component';
import { ClienteDetalleComponent } from './components/cliente-detalle/cliente-detalle.component';
import { NewFeeComponent } from './components/new-fee/new-fee.component';
import { NotificationsComponent } from './notifications/notifications.component';
import { ModalComponent } from './notifications/edit/edit.component';
import { AngularEditorModule } from '@kolkov/angular-editor';
import { PersonFeePaymentsComponent } from './components/person-fee-payments/person-fee-payments.component';

import { InactiveQuotaComponent } from './inactive-quota/inactive-quota.component';
import { DetailComponent } from './components/dashboard-fees/detail/detail.component';


import { NewPlanV2Component } from './components/plans/components/new-plan-v2/new-plan-v2.component';
import { CodesComponent } from './components/codes/codes.component';

import { CodeDynamicComponent } from './code-dynamic/code-dynamic.component';

import { ListComponent } from './components/plans/components/list/list.component';
import { SideBarComponent } from './components/side-bar/side-bar.component';
import { NewCodePeopleComponent } from './components/new-code-people/new-code-people.component';
// Imports from HEAD (your branch)
import { CodeTypeProductComponent } from './components/type-product/code-type-product/code-type-product.component';
import { ModalTypeProductComponent } from './components/type-product/code-type-product/modal-type-product/modal-type-product/modal-type-product.component';
import { ModalTypeProductNewComponent } from './components/type-product/code-type-product/modal-type-product-new/modal-type-product-new.component';
import { PayallBalanceComponent } from './components/payall-balance/payall-balance.component';

// Módulo de Recargas
import { RecargasComponent } from './components/recargas/recargas.component';
import { OperadorasListComponent } from './components/recargas/operadoras-list/operadoras-list.component';
import { TiposOperacionComponent } from './components/recargas/tipos-operacion/tipos-operacion.component';
import { ProductosComponent } from './components/recargas/productos/productos.component';
import { RecargasAdminComponent } from './admin/recargas-admin/recargas-admin.component';
import { ApprovalPolicyModeComponent } from './components/approval-policies/approval-policy-mode/approval-policy-mode.component';
import { CredolabThresholdsComponent } from './components/approval-policies/credolab-thresholds/credolab-thresholds.component';
import { CredolabFlagsComponent } from './components/approval-policies/credolab-flags/credolab-flags.component';

// Nuevo componente del dashboard de planes
import { PlansDashboardComponent } from './components/plans/plans-dashboard/plans-dashboard.component';
import { PlansWizardComponent } from './components/plans/components/plans-wizard/plans-wizard.component';
import { PlansWizardEditComponent } from './components/plans/components/plans-wizard-edit/plans-wizard-edit.component';

// Nuevo componente del dashboard de ventas
import { VentasDashboardComponent } from './components/ventas-dashboard/ventas-dashboard.component';
import { MulticomercioDashboardComponent } from './components/multicomercio-dashboard/multicomercio-dashboard.component';

// Nuevo componente del dashboard de finanzas 2.0
import { Finanzas2DashboardComponent } from './components/finanzas2-dashboard/finanzas2-dashboard.component';

// Nuevo componente del dashboard de cobranza
import { CobranzaDashboardComponent } from './components/cobranza-dashboard/cobranza-dashboard.component';

// Nuevo componente del dashboard de crédito
import { CreditoDashboardComponent } from './components/credito-dashboard/credito-dashboard.component';

// Nuevo componente de historial global de cupo
import { QuotaHistoryGlobalComponent } from './components/quota-history-global/quota-history-global.component';

// Nuevo componente del dashboard de parámetros de sistema
import { ParametrosSistemaDashboardComponent } from './components/parametros-sistema-dashboard/parametros-sistema-dashboard.component';

// Imports from incoming branch
import { DashboardRedistributePaymentComponent } from './components/dashboard-redistribute-payment/dashboard-redistribute-payment.component';
import { PaymentListComponent } from './components/payment-list/payment-list.component';
import { VersionTimelineComponent } from './components/dashboard-fees/version-timeline/version-timeline.component';
import { VersionDetailComponent } from './components/dashboard-fees/version-detail/version-detail.component';
import { ClientInstallmentsViewComponent } from './components/client-installments-view/client-installments-view.component';

// Async Admin Dashboard
import { AsyncAdminDashboardComponent } from './components/async-admin-dashboard/async-admin-dashboard.component';
import { PerfilBancarioComponent } from './components/perfil-bancario/perfil-bancario.component';
import { CuentasContratoComponent } from './components/perfil-bancario/cuentas-contrato/cuentas-contrato.component';
import { CuentasContratoEtiquetasComponent } from './components/perfil-bancario/cuentas-contrato/etiquetas/cuentas-contrato-etiquetas.component';
import { CuentasContratoTelefonoComponent } from './components/perfil-bancario/cuentas-contrato/telefono/cuentas-contrato-telefono.component';
import { AsyncAdminService } from './services/async-admin.service';

// Simulador de Caja Registradora
import { CashRegisterSimulatorComponent } from './components/cash-register-simulator/cash-register-simulator.component';

// Gestión de Tiendas
import { ComerciosListComponent } from './components/comercios/comercios-list/comercios-list.component';
import { ComerciosDetailComponent } from './components/comercios/comercios-detail/comercios-detail.component';
import { ComerciosTiendaComponent } from './components/comercios/comercios-tienda/comercios-tienda.component';
import { ComerciosUsuarioNuevoComponent } from './components/comercios/comercios-usuario-nuevo/comercios-usuario-nuevo.component';
import { ComerciosFormComponent } from './components/comercios/comercios-form/comercios-form.component';
import { ComerciosCondicionesComponent } from './components/comercios/comercios-condiciones/comercios-condiciones.component';
import { ComerciosCondicionesFormComponent } from './components/comercios/comercios-condiciones-form/comercios-condiciones-form.component';
import { CondicionesPasosComponent } from './components/comercios/condiciones-pasos/condiciones-pasos.component';
// 🔴 REDISEÑO 2026-09-20 — las siete pantallas que la ficha del comercio tenía
// adentro como solapas. Se declaran acá, al lado de sus hermanas.
import { ComerciosTiendasComponent } from './components/comercios/comercios-tiendas/comercios-tiendas.component';
import { ComerciosTiendaNuevaComponent } from './components/comercios/comercios-tienda-nueva/comercios-tienda-nueva.component';
import { ComerciosCuentasComponent } from './components/comercios/comercios-cuentas/comercios-cuentas.component';
import { ComerciosClientesComponent } from './components/comercios/comercios-clientes/comercios-clientes.component';
import { ComerciosContactosComponent } from './components/comercios/comercios-contactos/comercios-contactos.component';
import { ComerciosUsuariosComponent } from './components/comercios/comercios-usuarios/comercios-usuarios.component';
import { ComerciosAsistenteComponent } from './components/comercios/comercios-asistente/comercios-asistente.component';
import { ComerciosTemasComponent } from './components/comercios/comercios-temas/comercios-temas.component';

// Inteligencia artificial — la IA del núcleo (contrato: kredit-api-MT/modules/ia/CONTRATO.md §8.2)
import { IaComponent } from './components/ia/ia/ia.component';
import { IaEstadoComponent } from './components/ia/ia-estado/ia-estado.component';
import { IaAgentesComponent } from './components/ia/ia-agentes/ia-agentes.component';
import { IaComerciosComponent } from './components/ia/ia-comercios/ia-comercios.component';
import { IaBitacoraComponent } from './components/ia/ia-bitacora/ia-bitacora.component';
import { IaProbarComponent } from './components/ia/ia-probar/ia-probar.component';
import { IaCredencialesComponent } from './components/ia/ia-credenciales/ia-credenciales.component';
import { IaInterruptorComponent } from './components/ia/ia-interruptor/ia-interruptor.component';
import { IaRegistroComponent } from './components/ia/ia-registro/ia-registro.component';
import { IaRespuestaComponent } from './components/ia/ia-respuesta/ia-respuesta.component';

// Solicitudes de crédito — canal POS (contrato en
// ~/Documents/multicomercio/competencia/60-modulo-solicitudes-contrato.md)
import { SolicitudesCreditoListComponent } from './components/solicitudes-credito/solicitudes-credito-list/solicitudes-credito-list.component';
import { SolicitudesCreditoDetalleComponent } from './components/solicitudes-credito/solicitudes-credito-detalle/solicitudes-credito-detalle.component';
import { TiposFlujosComponent } from './components/tipos-flujos/tipos-flujos.component';
import { TipoFlujoDetalleComponent } from './components/tipos-flujos/tipo-flujo-detalle/tipo-flujo-detalle.component';
import { WorkflowsListaComponent } from './components/workflows/workflows-lista/workflows-lista.component';
import { WorkflowDetalleComponent } from './components/workflows/workflow-detalle/workflow-detalle.component';
import { AltasBandejaComponent } from './components/altas/altas-bandeja/altas-bandeja.component';
import { AltaNuevaComponent } from './components/altas/alta-nueva/alta-nueva.component';
import { AltaSolicitudComponent } from './components/altas/alta-solicitud/alta-solicitud.component';
import { AltaCargarComponent } from './components/altas/alta-cargar/alta-cargar.component';
import { CanalesVentaComponent } from './components/altas/canales-venta/canales-venta.component';
import { RielPasosComponent } from './components/altas/riel-pasos/riel-pasos.component';
import { CuentaBancariaComponent } from './components/altas/cuenta-bancaria/cuenta-bancaria.component';
import { RifInputComponent } from './components/altas/rif-input/rif-input.component';
import { KbMenuComponent } from './components/altas/kb-menu/kb-menu.component';
import { CentrosSelectComponent } from './components/altas/centros-select/centros-select.component';
import { PuestaEnMarchaComponent } from './components/altas/puesta-en-marcha/puesta-en-marcha.component';
import { PuestaEnMarchaEscenaComponent } from './components/altas/puesta-en-marcha-escena/puesta-en-marcha-escena.component';
// Cierre de caja — canal POS. Pantalla propia: contesta «qué se cobró este día»,
// que no es la pregunta de Cajas («cómo van mis turnos ahora»).
import { CierreDeCajaComponent } from './components/cierre-de-caja/cierre-de-caja.component';
// Documentación de integración — los manuales técnicos (marketplace y caja) y la colección de
// Postman, para que alguien de CrediTotal se los mande a un comercio que se va a integrar.
import { DocumentacionIntegracionComponent } from './components/documentacion-integracion/documentacion-integracion.component';
import { OrganizacionComponent } from './components/organizacion/organizacion.component';
import { ShopsListComponent } from './components/shops/shops-list/shops-list.component';
import { ShopDetailComponent } from './components/shops/shop-detail/shop-detail.component';
import { ShopService } from './services/shop/shop.service';

// Insurance Console Component
import { InsuranceConsoleComponent } from './components/insurance-console/insurance-console.component';
import { InsuranceInstallmentReportComponent } from './components/insurance-installment-report/insurance-installment-report.component';
import { SalesCollectionSummaryComponent } from './components/insurance-console/components/sales-collection-summary/sales-collection-summary.component';
import { TudocTrackingComponent } from './components/insurance-console/components/tudoc-tracking/tudoc-tracking.component';

// Modal compartido de "Confirmar reporte a la aseguradora"
import { InsuranceReportConfirmComponent } from './components/insurance-report-confirm/insurance-report-confirm.component';

// App Config Component
import { AppConfigComponent } from './components/app-config/app-config.component';
import { CarouselConfigComponent } from './components/app-config/carousel-config/carousel-config.component';

// Onboarding Modal Component
import { OnboardingModalComponent } from './components/onboarding-modal/onboarding-modal.component';
import { BancoPlazaConsoleComponent } from './components/banco-plaza-console/banco-plaza-console.component';
import { PaymentTermsBuilderComponent } from './components/plans/components/shared/payment-terms-builder/payment-terms-builder.component';

// Security Components - 2FA
import { Verify2faLoginComponent } from './components/auth/verify-2fa-login/verify-2fa-login.component';
import { Select2faMethodComponent } from './components/auth/select-2fa-method/select-2fa-method.component';
import { AccountLockedComponent } from './components/auth/account-locked/account-locked.component';
import { Setup2faModalComponent } from './components/auth/setup-2fa-modal/setup-2fa-modal.component';
import { PasswordRecoveryComponent } from './components/auth/password-recovery/password-recovery.component';
import { SeguridadAvanzadaComponent } from './components/security/seguridad-avanzada/seguridad-avanzada.component';
import { AppClientsComponent } from './components/app-clients/app-clients.component';
import { SecurityService } from './services/security/security.service';
import { RolesPermisosComponent } from './components/roles-permisos/roles-permisos.component';
import { AgregarPermisosComponent } from './components/roles-permisos/agregar-permisos/agregar-permisos.component';
import { OrganizarMatrizComponent } from './components/roles-permisos/organizar-matriz/organizar-matriz.component';

// Módulo de Gestión de Productos
import { CatalogProductsComponent } from './components/catalog-products/catalog-products.component';
import { CatalogProductDetailComponent } from './components/catalog-products/catalog-product-detail/catalog-product-detail.component';

// Widget embebido CRM
import { WidgetPaymentHistoryComponent } from './components/widget-payment-history/widget-payment-history.component';
import { WidgetCreditHistoryComponent } from './components/widget-credit-history/widget-credit-history.component';
import { WidgetPostComponent } from './components/widget-post/widget-post.component';
import { WidgetInstallmentsPlanComponent } from './components/widget-installments-plan/widget-installments-plan.component';

@NgModule({
  declarations: [
    AppComponent,
    DescargasEnCursoComponent,
    EmpresaCuentaPipe,
    EmpresaCuentaClasePipe,
    NavbarauthComponent,
    AppsLauncherComponent,
    LoginComponent,
    LogoutComponent,
    RegistroComponent,
    DashboardComponent,
    ChatComponent,
    SearchClientComponent,
    ConsultaPsicometricoComponent,
    ListOnlineComponent,
    ProfilesComponent,
    ContactsComponent,
    ContactProfileComponent,
    RewardsCardComponent,
    ConsultQuoteComponent,
    CreditOptionComponent,
    ConsultQuotaComponent,
    CreditCalculatorComponent,
    CreditSaveComponent,
    CreditSaveV2Component,
    InvoiceComponent,
    ValidatePhoneComponent,
    ApproveConditionsComponent,
    ApprovalPoliciesComponent,
    AgeLimitsComponent,
    GroupListComponent,
    WorkConditionMasterComponent,
    ContactOnboardingComponent,
    ContactSapComponent,
    ContactOdooComponent,
    SapHubComponent,
    OdooClientesComponent, OdooComerciosComponent, OdooFechaCortaPipe, OdooDiaLargoPipe, OdooHoraSolaPipe, OdooRifPipe, OdooFrasePipe,
    OdooPanelComponent, OdooResumenComponent, OdooArchivosComponent,
    OdooGeneracionComponent,
    OdooBitacoraComponent, OdooConfigComponent, OdooToastComponent, OdIconComponent, OdPaginadorComponent, OdSheetComponent, OdKvComponent, OdEventoDetalleComponent,
    OdooEstadoPipe, OdooFechaPipe, OdooDiaPipe, OdooUsdPipe, OdooTipoPipe, OdooAccionPipe, OdooHoraPipe,
    ContactFinancialPaymentsComponent,
    PostComponent,
    OtrosFlujosPagoComponent,
    NotaCreditoComponent,
    PersonPaymentsComponent,
    PersonPaymentsTableComponent,
    PersonPaymentsSwitcherComponent,
    PreferenciasComponent,
    TarifarioComponent,
    FeriadosComponent,
    LiquidacionDiaComponent,
    LiquidacionLotesComponent,
    EstampaComercioComponent,
    CopiarComponent,
    FichaLiquidacionComponent,
    AtencionComerciosComponent,
    FichaTandaComponent,
    LiquidacionPorResolverComponent,
    LiquidacionConsultasComponent,
    LiquidacionMarcaVentaComponent,
    LiquidacionCuentasComponent,
    LiquidacionCuotasMediasComponent,
    CargandoCuadrosComponent,
    LiquidacionUtilidadComponent,
    LiquidacionCuentasCtComponent,
    LiquidacionCuadreDiaComponent,
    LiquidacionAvisoComponent,
    LiquidacionSaludCobrosComponent,
    LiquidacionReversosComponent,
    LiquidacionCobranzaComponent,
    LiquidacionCalendarioComponent,
    LiquidacionCalendarioMesComponent,
    CuentasOrigenComponent,
    ParametrosLiquidacionComponent,
    MontoBsComponent,
    LiquidacionFirmaComponent,
    LiquidacionResumenComponent,
    LiquidacionGuiaComponent,
    LiquidacionGuiaDiagramasComponent,
    BandasComponent,
    IntegracionesComponent,
    WebcamComponent,
    BiometriaComponent,
    FinancialPaymentsComponent,
    PaymentsComponent,
    FinancePaymentsTableComponent,
    FinancePaymentsSwitcherComponent,
    StadisticComponent,
    InstallmentsConsoleComponent,
    DataProfileComponent,
    AddressComponent,
    WorkingConditionComponent,
    IncomeComponent,
    ReportComponent,
    ContactsApprovatedComponent,
    ExportComponent,
    CreateContactComponent,
    DashboardInviceComponent,
    UsersComponent,
    LineChartComponent,
    BarChartComponent,
    DemographicBarChartComponent,
    FinancalDashboardComponent,
    StadisticDashboardComponent,
    StadisticEjecutivesComponent,
    DashboardDirecDebitComponent,
    DomiciliationConfigDashboardComponent,
    DomiciliacionCtCardComponent,
    DomiciliacionCtAvanceComponent,
    EstadoCtBadgeComponent,
    CobrosReaderComponent,
    RegistroCobrosArchivoComponent,
    PaymentMethodComponent,
    InsuranceDomiciliationSimulatorComponent,
    DndComponent,
    DndAlliancesComponent,
    DndAfiliationComponent,
    ProgressDndComponent,
    DndDirective,
    DirecDebitHistoryComponent,
    EditComponent,
    NotificationXlsxComponent,
    NumbersOnlyDirective,
    DashboardDirecDebitAlliancesComponent,
    RatesComponent,
    PlansComponent,
    PlanDetailComponent,
    NewPlanComponent,
    CargaMasivaClientComponent,
    DirecDebitAlliancesHistoryComponent,
    TraceDocumentComponent,
    EditDataBaseComponent,
    DashboardDirectDebitAffiliationComponent,
    DirecDebitAfiliationsHistoryComponent,
    ConciliationProgressMonitorComponent,
    ClientPlansComponent,
    AccountsAdminComponent,
    PaymentOptionsComponent,
    DeactivationCategoriesComponent,
    CarteraCastigadaComponent,
    BdvAsyncManagementComponent,
    BdvConsultasComponent,
    CargaMasivaAprobacionesComponent,
    CargaMasivaCuposComponent,
    CargaMasivaCuposRewardsComponent,
    CargaMasivaC004Component,
    ClientsStadisticAuthComponent,
    OrdersExportsComponent,
    DashboardFeesComponent,
    ProcesosMasivosComponent,
    ProcesoDetalleComponent,
    CarteraComponent,
    ClienteDetalleComponent,
    NewFeeComponent,
    NotificationsComponent,
    ModalComponent,
    InactiveQuotaComponent,
    PersonFeePaymentsComponent,
    DetailComponent,
    NewPlanV2Component,
    CodesComponent,
    CodeDynamicComponent,
    ListComponent,
    SideBarComponent,
    NewCodePeopleComponent,
    // Declarations from HEAD (your branch)
    CodeTypeProductComponent,
    ModalTypeProductComponent,
    ModalTypeProductNewComponent,
    PayallBalanceComponent,
    RecargasComponent,
    OperadorasListComponent,
    TiposOperacionComponent,
    ProductosComponent,
    RecargasAdminComponent,
    ApprovalPolicyModeComponent,
    CredolabThresholdsComponent,
    CredolabFlagsComponent,
    PlansDashboardComponent,
    PlansWizardComponent,
    PlansWizardEditComponent,
    VentasDashboardComponent,
    MulticomercioDashboardComponent,
    Finanzas2DashboardComponent,
    CobranzaDashboardComponent,
    CreditoDashboardComponent,
    QuotaHistoryGlobalComponent,
    ParametrosSistemaDashboardComponent,
    // Declarations from incoming branch
    DashboardRedistributePaymentComponent,
    PaymentListComponent,
    VersionTimelineComponent,
    VersionDetailComponent,
    // New component for client installments view
    ClientInstallmentsViewComponent,
    AsyncAdminDashboardComponent,
    PerfilBancarioComponent,
    CuentasContratoComponent,
    CuentasContratoEtiquetasComponent,
    CuentasContratoTelefonoComponent,
    CashRegisterSimulatorComponent,
    // Shops management components
    ComerciosListComponent,
    ComerciosDetailComponent,
    ComerciosTiendaComponent,
    ComerciosUsuarioNuevoComponent,
    ComerciosFormComponent,
    ComerciosCondicionesComponent,
    ComerciosCondicionesFormComponent,
    CondicionesPasosComponent,
    ComerciosTiendasComponent,
    ComerciosTiendaNuevaComponent,
    ComerciosCuentasComponent,
    ComerciosClientesComponent,
    ComerciosContactosComponent,
    ComerciosUsuariosComponent,
    ComerciosAsistenteComponent,
    ComerciosTemasComponent,
    IaComponent,
    IaEstadoComponent,
    IaAgentesComponent,
    IaComerciosComponent,
    IaBitacoraComponent,
    IaProbarComponent,
    IaCredencialesComponent,
    IaInterruptorComponent,
    IaRegistroComponent,
    IaRespuestaComponent,
    SolicitudesCreditoListComponent,
    SolicitudesCreditoDetalleComponent,
    TiposFlujosComponent,
    TipoFlujoDetalleComponent,
    WorkflowsListaComponent,
    WorkflowDetalleComponent,
    AltasBandejaComponent,
    AltaNuevaComponent,
    AltaSolicitudComponent,
    AltaCargarComponent,
    CanalesVentaComponent,
    RielPasosComponent,
    CuentaBancariaComponent,
    RifInputComponent,
    KbMenuComponent,
    CentrosSelectComponent,
    PuestaEnMarchaComponent,
    PuestaEnMarchaEscenaComponent,
    CierreDeCajaComponent,
    DocumentacionIntegracionComponent,
    OrganizacionComponent,
    ShopsListComponent,
    ShopDetailComponent,
    InsuranceConsoleComponent,
    InsuranceInstallmentReportComponent,
    SalesCollectionSummaryComponent,
    TudocTrackingComponent,
    InsuranceReportConfirmComponent,
    AppConfigComponent,
    CarouselConfigComponent,
    OnboardingModalComponent,
    BancoPlazaConsoleComponent,
    PaymentTermsBuilderComponent,
    // Security Components - 2FA
    Verify2faLoginComponent,
    Select2faMethodComponent,
    AccountLockedComponent,
    Setup2faModalComponent,
    PasswordRecoveryComponent,
    SeguridadAvanzadaComponent,
    AppClientsComponent,
    RolesPermisosComponent,
    AgregarPermisosComponent,
    OrganizarMatrizComponent,
    CatalogProductsComponent,
    CatalogProductDetailComponent,
    // Widget embebido CRM
    WidgetPaymentHistoryComponent,
    WidgetCreditHistoryComponent,
    WidgetPostComponent,
    WidgetInstallmentsPlanComponent
  ],

  imports: [
    FormsModule,
    ReactiveFormsModule,
    MbscModule,
    JwtModule.forRoot({
      config: {
        // allowedDomains: ['example.com'],
        //disallowedRoutes: ['/assets/config.json'],
        blacklistedRoutes: ['/assets/config.json'],
      },
    }),
    HttpClientModule,
    BrowserModule,
    AppRoutingModule,
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: environment.production,
      registrationStrategy: 'registerImmediately'
    }),
    NgbModule,
    CommonModule,
    WebcamModule,
    InfiniteScrollModule,
    NgToggleModule,
    CurrencyMaskModule,
    AngularEditorModule,
    QuillModule.forRoot()
  ],
  providers: [
    {
      // Modo marcador (iframe de «Agregar permisos»): rechaza todo lo que no sea GET. Va primero. Fuera de ese modo no hace nada.
      provide: HTTP_INTERCEPTORS,
      useClass: RbacMarcadorInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptorService,
      multi: true
    },
    {
      // Le agrega el comercio activo a cada lectura del núcleo. Un lugar, no 56.
      provide: HTTP_INTERCEPTORS,
      useClass: ComercioInterceptorService,
      multi: true
    },
    SocketioService,
    AuthService,
    UserService,
    PaymentOptionsService,
    ApprovalPoliciesService,
    LaService,
    IdentGuard,
    IsAuthGuard,
    NoAuthGuard,
    IsProfileGuard,
    IsPermissionGuard,
    DirectDebitService,
    AsyncAdminService,
    BdvAsyncManagementService,
    ShopService,
    SecurityService,
    CurrencyPipe
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
